import { SVGProps } from 'react';

export const LineChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="22,6 13,17 8.5,12.5 2,18" />
    <polyline points="22,6 18,6 18,10" />
  </svg>
);
